import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from "@angular/common";
import {ProcessReportPageComponent} from "app_sasha/pages/process-report/process-report-page.component";
import {ProcessReportDomainService} from "app_sasha/pages/process-report/process-report-domain.service";
import {ProcessReportPageRouting} from "app_sasha/pages/process-report/process-report-page.routing";
import {
    ProcessReportSearchFormComponent
} from "app_sasha/pages/process-report/components/process-report-search-form/process-report-search-form.component";
import {SashaBreadcrumbModule} from "app_sasha/shared/components/breadcrumb/sasha-breacrumb.module";
import {TitleServiceModule} from "app_sasha/shared/services/title/title-service.module";
import {CardFormModule} from "libraries/module/formbuilder/forms/card-form/card-form.module";
import {BtnModule} from "libraries/ui_button/btn.module";
import {MultiselectModule} from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import {SearchFormHelperModule} from "app_sasha/shared/services/search-form-helper/search-form-helper.module";
import {DateRangeModule} from "libraries/module/formbuilder/fields/date-range/date-range.module";
import {QueryParamsMappingService} from "app_sasha/pages/process-report/query-params-mapping.service";
import {ErrorTracingModule} from "libraries/service/error-tracing/error-tracing.module";
import {ProcessReportResourceModule} from "app_sasha/shared/resources/process-report/process-report-resource.module";
import {DatePipeModule} from "libraries/date/date.module";
import {SearchSummaryModule} from "libraries/component/search-summary/search-summary.module";
import {LabelModule} from "libraries/service/label/label.module";
import {
    ProcessReportTableComponent
} from "app_sasha/pages/process-report/components/process-report-table/process-report-table.component";
import {ConfigurationResourceModule} from "libraries/service/resources/configuration/configurationResource.module";
import {
    ProcessReportTableDomainService
} from "app_sasha/pages/process-report/components/process-report-table/process-report-table-domain.service";
import {MatTableModule} from "@angular/material/table";
import {ThTextModule} from "libraries/component/table/th-text/th-text.module";
import {TdTextModule} from "libraries/component/table/td-text/td-text.module";
import {CardModule} from "libraries/ui_card/card.module";
import {ConfigurableTablePipeModule} from "libraries/pipes/configurable-table/configurable-table-pipe.module";
import {PriceModule} from "libraries/component/price/price.module";
import {DateModule} from "libraries/module/formbuilder/fields/date/date.module";
import {BookingStatusModule} from "libraries/component/booking/booking-status/booking-status.module";
import {NotificationModule} from "libraries/component/notification/notification.module";
import {LoaderModule} from "libraries/component/loader/loader.module";
import {HostAliasPipeModule} from "libraries/pipes/host-alias/host-alias-pipe.module";
import {ComputeProcessBookingLinkPipe} from "app_sasha/pages/process-report/pipes/computeProcessBookingLink.pipe";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {IsTruelyModule} from "libraries/pipes/is-truely/is-truely.module";
import {
    ProcessReportPaginationComponent
} from "app_sasha/pages/process-report/components/process-report-table/process-report-pagination.component";
import {SimpleSelectModule} from "libraries/module/formbuilder/fields/simple-select/simple-select.module";

@NgModule({
    imports: [
        BookingStatusModule,
        BtnModule,
        CardFormModule,
        CardModule,
        CommonModule,
        ConfigurableTablePipeModule,
        ConfigurationResourceModule,
        DatePipeModule,
        DateRangeModule,
        ErrorTracingModule,
        FontAwesomeModule,
        HostAliasPipeModule,
        IsTruelyModule,
        LabelModule,
        LoaderModule,
        MatTableModule,
        MultiselectModule,
        NotificationModule,
        PriceModule,
        ProcessReportPageRouting,
        ProcessReportResourceModule,
        SashaBreadcrumbModule,
        SearchFormHelperModule,
        SearchSummaryModule,
        SimpleSelectModule,
        TdTextModule,
        ThTextModule,
        TitleServiceModule,
    ],
    exports: [
        ProcessReportPageComponent,
        ComputeProcessBookingLinkPipe,
    ],
    declarations: [
        ProcessReportPageComponent,
        ProcessReportSearchFormComponent,
        ProcessReportTableComponent,
        ComputeProcessBookingLinkPipe,
        ProcessReportPaginationComponent,
    ],
    providers: [
        ProcessReportDomainService,
        QueryParamsMappingService,
        ProcessReportTableDomainService,
    ],
})
export class ProcessReportPageModule {
}
